import React, { useMemo } from "react"

import { BreadcrumbDefaultButton } from "src/components/SegmentPicker/components/ListItemBreadcrumb/styled"
import { truncatePathParts } from "src/components/SegmentPicker/components/ListItemBreadcrumb/helpers/truncatePathParts"
import { BreadcrumbBuilder } from "src/components/SegmentPicker/components/ListItemBreadcrumb/sub-components/BreadcrumbBuilder"
import { IBreadcrumbDisplayProps } from "src/components/SegmentPicker/components/ListItemBreadcrumb/sub-components/BreadcrumbDisplay/types"

/**
 * Component to render breadcrumb display content with optional truncation
 */
export const BreadcrumbDisplay = ({
    allPathPairs,
    shouldTruncate,
    segmentId,
}: IBreadcrumbDisplayProps) => {
    // Calculate appropriate display content based on truncation state
    const displayPairs = useMemo(
        () => (shouldTruncate ? truncatePathParts(allPathPairs) : allPathPairs),
        [allPathPairs, shouldTruncate],
    )

    return (
        <>
            {displayPairs.map((pair, i) => (
                <React.Fragment key={i}>
                    {i > 0 && <span style={{ margin: "0 4px" }}>/</span>}
                    <BreadcrumbBuilder
                        pathPairs={[pair]}
                        segmentId={segmentId}
                        Component={BreadcrumbDefaultButton}
                    />
                </React.Fragment>
            ))}
        </>
    )
}
